import React from 'react';
import ReactDOM from 'react-dom/client';
import * as Sentry from '@sentry/react';
import { BrowserRouter } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import { initSentry } from './lib/sentry.js';
import App from './App.jsx';
import './styles/global.css';

initSentry();

function ErrorFallback() {
  return (
    <div role="alert" style={{
      minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center',
      background: '#0a0a0a', color: '#f5f1e8', fontFamily: 'system-ui, sans-serif',
      padding: 24, textAlign: 'center',
    }}>
      <div style={{ maxWidth: 480 }}>
        <div style={{ color: '#ff5f1f', fontSize: 13, fontWeight: 700, letterSpacing: '0.04em', textTransform: 'uppercase', marginBottom: 16 }}>
          tender-api.com
        </div>
        <h1 style={{ fontSize: 28, fontWeight: 700, margin: '0 0 12px' }}>Page failed to render</h1>
        <p style={{ color: '#a3a09a', lineHeight: 1.55, margin: '0 0 24px' }}>
          Sentry has the trace. Reload the page; if the problem persists, ping support@tender-api.com with the request ID from your console.
        </p>
        <button
          type="button"
          onClick={() => window.location.reload()}
          style={{
            padding: '12px 20px', background: '#ff5f1f', color: '#fff',
            border: 0, borderRadius: 6, fontWeight: 600, fontSize: 14, cursor: 'pointer',
          }}
        >
          Reload
        </button>
      </div>
    </div>
  );
}

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <HelmetProvider>
      <BrowserRouter>
        <Sentry.ErrorBoundary fallback={<ErrorFallback />}>
          <App />
        </Sentry.ErrorBoundary>
      </BrowserRouter>
    </HelmetProvider>
  </React.StrictMode>,
);
